interface TextareaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  rows?: number;
  error?: string;
}

export default function TextareaField({
  label,
  value,
  onChange,
  required = false,
  placeholder,
  rows = 4,
  error,
}: TextareaFieldProps) {
  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={`w-full bg-[#1a1f3a] border rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 resize-none ${
          error ? 'border-red-500/50' : 'border-[#2d1b3d]'
        }`}
      />
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



